import { render, staticRenderFns } from "./user_change_infor.vue?vue&type=template&id=34270836&"
import script from "./user_change_infor.vue?vue&type=script&lang=js&"
export * from "./user_change_infor.vue?vue&type=script&lang=js&"
import style0 from "./user_change_infor.vue?vue&type=style&index=0&id=34270836&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports